import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import * as API from "../Endpoints/Endpoints";

const AddChakraGame = ({ type }) => {
  const [formData, setFormData] = useState({
    theme: "",
    agentname: "",
    description: "",
    answer: "",
    number: "",
    value: ""
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const payload =
      type === "spoke"
        ? {
            theme: formData.theme,
            agentname: formData.agentname,
            description: formData.description,
            answer: formData.answer,
            spokenumber: formData.number,
            spoke: formData.value
          }
        : {
            theme: formData.theme,
            agentname: formData.agentname,
            description: formData.description,
            answer: formData.answer,
            bladenumber: formData.number,
            blade: formData.value
          };

    const apiUrl = type === "spoke" ? API.POST_SPOKE_API : API.POST_BLADE_API;

    try {
      await axios.post(apiUrl, payload);
      alert(`${type === "spoke" ? "Spoke" : "Blade"} added successfully`);
      navigate("/chakragametable");
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to add data");
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">
        Add {type === "spoke" ? "Spoke" : "Blade"}
      </h2>

      <input name="theme" value={formData.theme} onChange={handleChange} placeholder="Theme" className="border p-2 mb-2 w-full" />
      <input name="agentname" value={formData.agentname} onChange={handleChange} placeholder="Agent Name" className="border p-2 mb-2 w-full" />
      <input name="description" value={formData.description} onChange={handleChange} placeholder="Description" className="border p-2 mb-2 w-full" />
      <input name="answer" value={formData.answer} onChange={handleChange} placeholder="Answer" className="border p-2 mb-2 w-full" />
      <input name="number" value={formData.number} onChange={handleChange} placeholder={type === "spoke" ? "Spoke Number" : "Blade Number"} className="border p-2 mb-2 w-full" />
      <input name="value" value={formData.value} onChange={handleChange} placeholder={type === "spoke" ? "Spoke" : "Blade"} className="border p-2 mb-2 w-full" />

      <button onClick={handleSubmit} className="bg-[#e64a32] text-white px-4 py-2 rounded">
        Submit
      </button>
    </div>
  );
};

export default AddChakraGame;
